import { Box, HStack } from '@chakra-ui/react';

import AppCard from './ApplicationCard';
import { applicationConfig } from '../config';

const ApplicationList = () => {
  return (
    <>
      <Box h="100%" w="100%" display={"grid"}>
        <HStack spacing='12px'>
          {applicationConfig.map((app) => (
            <AppCard key={app.appName} {...app} />
          ))}
        </HStack>
      </Box>
    </>
  );
};

export default ApplicationList;
